import dormimundo from "../assets/logo-dormimundo.png";
import liverpool from "../assets/liverpoolNew.png";
import cropped from "../assets/jd_joyeros.png";
import CTS from "../assets/CTSViajes.png";
import cesarAlvarez from "../assets/CesarAlvarezDj.jpg";
import dpaul from "../assets/dpaul.png";
import floresMeyer from "../assets/floresMeyer.png";
import lautrichienne from "../assets/lautrichienne.png";
import mauricioRenteria from "../assets/mauricioRenteria.png";
import recordArte from "../assets/recordArte.png";
import patrocinadores_title from "../assets/patrocinadores.png";
import silviagalvan from "../assets/silviagalvan.png";
import miele from "../assets/logo-miele.png";


const Footer = () => {
  return (
    <footer className="global__footer mt-5">
      <div className="container">
	  	<div class="row align-items-center">
	  		<div class="col">
	  			<img src={patrocinadores_title} alt="Patrocinadores" class="index__title w-100 my-2 my-sm-4" />
	  		</div>
	  	</div>
        <div className="row align-items-center justify-content-md-center">
          <div className="col pb-3">
            <img alt="Logo Dormimundo" height="145px" src={dormimundo}
            />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Liverpool" height="120px" src={liverpool} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Cropped" height="120px" src={cropped} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="CTS" height="150px" src={CTS} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img height="125px" alt="DJ Cesar Alvarez" src={cesarAlvarez} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="DPaul" src={dpaul} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Flores Meyer" src={floresMeyer} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img height="125px" alt="Lautrichienne" src={lautrichienne} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Mauricio Renteria" src={mauricioRenteria} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Record Arte" src={recordArte} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Silvia Galvan" src={silviagalvan} />
          </div>
          <div className="col-6 col-sm-3  pb-3">
            <img alt="Miele" src={miele} />
          </div>

        </div>
      </div>
      <p className="text-center px-5 pb-3 footer_rights">
        © Todos los Derechos Reservados de Media Marketing Knowledge Group
        www.mmkgroup.com.mx
      </p>
    </footer>
  );
};

export default Footer;
